import React, { FC } from 'react';
import { SearchResultDTOTypeEnum, SloDTO } from '@atlassiansox/phobos-client-ts';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import Button from '@atlaskit/button';

import { flexStart, spaceGapMinimum, tableExpandButtonStyles } from '@/styles';
import { noop } from '@/utils';
import { isIndicatorTypeMimir } from '@/components/composed/slo-group/utils';
import MimirLogo from '@/components/primitive/mimir/logo';

import { testIds } from '../../constants';
import { SearchResultItemType } from '../types';

type SearchListTypeProps = {
  type: SearchResultDTOTypeEnum;
  isCardExpanded: boolean;
  hideType?: boolean;
  item?: SearchResultItemType;
};

const SearchListType: FC<SearchListTypeProps> = ({
  type,
  isCardExpanded,
  hideType = false,
  item,
}) => {
  const isMimir =
    type === SearchResultDTOTypeEnum.SloGroup && isIndicatorTypeMimir((item as SloDTO)?.indicator);

  return (
    <div css={[flexStart]}>
      <span css={tableExpandButtonStyles}>
        <Button
          spacing="none"
          appearance="subtle"
          onClick={noop}
          testId={testIds.searchResultListTitleAction}
        >
          {isCardExpanded && <ChevronDownIcon size="medium" label="" />}
          {!isCardExpanded && <ChevronRightIcon size="medium" label="" />}
        </Button>
      </span>
      {!hideType && (
        <span css={[flexStart, spaceGapMinimum]}>
          {type.replace(/_/gi, ' ')}
          {isMimir && <MimirLogo />}
        </span>
      )}
    </div>
  );
};

export default SearchListType;
